import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import { Provider } from "react-redux";
import { Component, lazy, Suspense } from "react";
import { LoadScript } from "@react-google-maps/api";
// import configureStore from "./store/store";
// import Layout from "./components/Layout";
// import ReRoutes from "./components/ReRoutes";

/* Every route target is loaded through React.lazy so webpack emits one async
   chunk per page instead of folding all of them into bundle.js. */
const Home = lazy(() => import("./pages/DestinationServicesStatic/pricing/Home"));
const ContactUs = lazy(() => import("./pages/DestinationServicesStatic/pricing/ContactUs"));
const Pricing = lazy(() => import("./pages/DestinationServicesStatic/pricing/Pricing"));
const NoUserHeaderMenu = lazy(() =>
  import("./common/header/Header").then((m) => ({ default: m.NoUserHeaderMenu }))
);
const NoPageFound = lazy(() => import("./pages/DestinationServicesStatic/noPageFound/NoPageFound"));
const Layout = lazy(() => import("./common/layout/Layout"));
const Login = lazy(() => import("./pages/DestinationServicesStatic/authLogin/Login"));
const NewHomePage = lazy(() => import("./pages/DestinationServicesStatic/home/newHomePage"));
//  supplier routes
const SupplierLayout = lazy(() => import("./pages/Supplier/SupplierLayout"));
const Dashboard = lazy(() => import("./pages/Supplier/Dashboard/Dashboard"));
const ConsultantList = lazy(() => import("./pages/Supplier/ConsultantList/ConsultantList"));
const ClientProfileList = lazy(() => import("./pages/Supplier/ClientProfileList/ClientProfileList"));
const Reports = lazy(() => import("./pages/Supplier/Reports/Reports"));
const AppointementReports = lazy(() => import("./pages/Supplier/Reports/AppointementReports"));
const TransfereeReports = lazy(() => import("./pages/Supplier/Reports/TransfereeReports"));
const BillingReports = lazy(() => import("./pages/Supplier/Reports/BillingReports"));
const SupplierTransfereeList = lazy(() => import("./pages/Supplier/TransfereeList/SuppliertransfereeList"));
const Transfereemoredetails = lazy(() => import("./pages/Supplier/moredetails/transfereemoredetails"));

// ---------------------

// Transferee routes
const GetStartedFirstTime = lazy(() => import("./pages/Transferee/getStarted/getStartedFirstTime"));
const TransfereeLayout = lazy(() => import("./pages/Transferee/TransfereeLayout"));
const Dslanding = lazy(() => import("./pages/Transferee/dsHome/Dslanding"));
const DSHelp = lazy(() => import("./pages/Transferee/dsHome/dsHelp"));
const GetStarted = lazy(() => import("./pages/Transferee/getStarted/getStarted"));
// import CityLanding from "./pages/Transferee/cityLanding/cityLanding";
const CityLanding = lazy(() => import("./pages/Transferee/cityLanding/cityLanding"));
const ResourceLanding = lazy(() => import("./pages/Transferee/resume/resource"));
const RentersResume = lazy(() => import("./pages/Transferee/resume/rentersResume"));
const PetResume = lazy(() => import("./pages/Transferee/resume/petResume"));
const DieDetails = lazy(() => import("./pages/Transferee/DieDetails/dieDetails"));
const MyProperties = lazy(() => import("./pages/Transferee/myProperties/myProperties"));
const CheckList = lazy(() => import("./pages/Transferee/checkList/CheckList"));
const DsProfile = lazy(() => import("./pages/Transferee/dsProfile/dsProfile"));
const DsSoloProfile = lazy(() => import("./pages/Transferee/dsProfile/dsSoloProfile"));
const MyPropertyDetails = lazy(() => import("./pages/Transferee/myProperties/myPropertyDetails"));
const SoloLanding = lazy(() => import("./pages/Transferee/solo/soloLanding"));
const CommanderLanding = lazy(() => import("./pages/Transferee/solo/commanderLanding"));
const Maplist = lazy(() => import("./pages/Transferee/compareMapList/maplist"));
// --------------------

// consultant routes
const ConsultantLayout = lazy(() => import("./pages/Consultant/ConsultantLayout"));
const ConsultantDashboard = lazy(() => import("./pages/Consultant/ConsultantDashboard/ConsultantDashboard"));
const Schedule = lazy(() => import("./pages/Consultant/Schedule/Schedule"));
const TransfereeList = lazy(() => import("./pages/Consultant/Transeferee/TransfereesList"));
const MoreDetail = lazy(() => import("./pages/Consultant/moredetails/moredetails"));
const Properties = lazy(() => import("./pages/Consultant/Property/Properties"));
const ConsultantReports = lazy(() => import("./pages/Consultant/reports/ConsultantReports"));
const ConsultantAppointementReports = lazy(() => import("./pages/Consultant/reports/ConsultantAppointementReports"));
const ConsultantTransfereeReports = lazy(() => import("./pages/Consultant/reports/ConsultantTransfereeReports"));
const UsageDashboard = lazy(() => import("./pages/Consultant/UsageDashboard/UsageDashboard"));
const Chatting = lazy(() => import("./pages/Consultant/chat/chatting"));
const ConsultantProfile = lazy(() => import("./pages/Consultant/ConsultantProfile/ConsultantProfile"));
const MyProperty = lazy(() => import("./pages/DestinationServicesStatic/myProperties/myPropertyDetails"));
const LoginForce = lazy(() => import("./pages/DestinationServicesStatic/authLogin/LoginForce"));
const MapBoxPractice = lazy(() => import("./common/mapBoxPractice"));
const MapDrawCircle = lazy(() => import("./pages/Transferee/cityLanding/googleMapdraw"));
const NewPublicPage = lazy(() => import("./pages/DestinationServicesStatic/newpublicPage/newPublicPage"));
const PublicContactUs = lazy(() => import("./pages/DestinationServicesStatic/newpublicPage/common/publicContactUs"));
const PublicLayout = lazy(() => import("./pages/DestinationServicesStatic/newpublicPage/publicLayout/publicLayout"));
const ForIndividuals = lazy(() => import("./pages/DestinationServicesStatic/newpublicPage/forIndividuals"));

const RentCalculatorPage = lazy(() => import("./pages/Transferee/resume/rentCalculator"));
const RentalFAQ = lazy(() => import("./pages/Transferee/resume/rentalFAQ"));
const ForConsultant = lazy(() => import("./pages/DestinationServicesStatic/newpublicPage/forConsultant"));
const ForCompaniesPage = lazy(() => import("./pages/DestinationServicesStatic/newpublicPage/forCompanies"));
const BaseMap = lazy(() => import("./pages/Transferee/cityLanding/map/BaseMap"));
//ai assistant
const AIAssistant = lazy(() => import("./pages/Transferee/aiAssistant/aiAssistant"));
// --------------------
const NewReloPublicPage = lazy(() => import("./pages/DestinationServicesStatic/newpublicPage/newReloPublicPage"));
const NewPublicLayout = lazy(() => import("./pages/DestinationServicesStatic/newpublicPage/newPublicLayout"));
const RentersPDFDowload = lazy(() => import("./pages/pdfDownload/pdfDownload"));
const PetPdfDownload = lazy(() => import("./pages/pdfDownload/petPdfDowload"));
const NewCityLanding = lazy(() => import("./pages/Transferee/cityLanding/newCityLanding"));
const PropertyListDetails = lazy(() => import("./pages/Transferee/searchPropertyList/propertyListDetails"));
const ReactLogOut = lazy(() => import("./common/header/reactLogout"));
const HolidayCalendar = lazy(() => import("./pages/Transferee/holidayCalendar/holidayCalendar"));
const HireanEexpert = lazy(() => import("./pages/Transferee/hireanexpert/hireanexpert"));

const MAP_LIBRARIES = ["places", "drawing"];
const MAPS_API_KEY = GoogleApiKey || googlekey || "";

/* The same branded loader the pages use. Its styles come from relo-custom.css,
   which index.html links in <head>, so it is already painted by the time this
   renders from the entry bundle. */
const RouteFallback = () => <div className="loading" />;

/* A code-split app can fail to fetch a chunk (stale hash after a deploy, flaky
   network). Without this the fallback spins forever, so retry the fetch once by
   reloading and only then surface the failure. */
class RouteErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    const isChunkError = /Loading chunk|Loading CSS chunk|ChunkLoadError|dynamically imported module/i.test(
      (error && (error.message || error.name)) || ""
    );
    if (isChunkError && !sessionStorage.getItem("reloChunkReloaded")) {
      sessionStorage.setItem("reloChunkReloaded", "1");
      window.location.reload();
    }
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="text-center" style={{ padding: "80px 20px" }}>
          <p>Something went wrong while loading this page.</p>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              sessionStorage.removeItem("reloChunkReloaded");
              window.location.reload();
            }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const AllRoutes = () => {
  window.addEventListener("popstate", function () {
    $(".modal-backdrop").remove();
    $("body").removeClass("modal-open").css("overflow", "");
  });
  return (
    // LoadScript withholds its children until the Maps script resolves and
    // otherwise paints a bare "Loading..." div, so it needs the same loader as
    // Suspense to cover that first stretch of the page load.
    <LoadScript
      googleMapsApiKey={MAPS_API_KEY}
      libraries={MAP_LIBRARIES}
      loadingElement={<RouteFallback />}
    >
      <BrowserRouter>
        <RouteErrorBoundary>
        <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/mapBox" element={<MapBoxPractice />} />
          <Route path="/mapdraw" element={<MapDrawCircle />} />
          <Route path="/newHome" element={<NewHomePage />}></Route>
          <Route
            path="/renterspdfDowload"
            element={<RentersPDFDowload />}
          ></Route>
          <Route path="/petpdfDownload" element={<PetPdfDownload />}></Route>
          <Route path="/mobileLogOut" element={<ReactLogOut />}></Route>

          {/* <Route path="/" element={<Login />} /> */}
          <Route path="/login" element={<Login />} />
          <Route path="/porchlight" element={<Login />} />
          <Route path="/loginforce" element={<LoginForce />} />
          <Route path="/." element={<NoUserHeaderMenu />} />
          <Route path="/page-not-found" element={<NoPageFound />} />
          <Route path="" element={<NewPublicLayout />}>
            <Route path="/" element={<NewReloPublicPage />} />
            <Route path="/contact-us" element={<PublicContactUs />}></Route>
          </Route>
          <Route path="" element={<PublicLayout />}>
            <Route path="/index-info" element={<NewPublicPage />}></Route>
            {/* <Route path="/contact-us" element={<PublicContactUs />}></Route> */}
            <Route path="/forCompanies" element={<ForCompaniesPage />}></Route>
            <Route path="/forConsultant" element={<ForConsultant />}></Route>
            <Route path="/individuals" element={<ForIndividuals />}></Route>
          </Route>

          <Route path="" element={<Layout />}>
            <Route path="/home" element={<Home />}></Route>

            <Route path="/homee" element={<Home />}></Route>
            <Route path="/pricing" element={<Pricing />}></Route>
            <Route path="/contactus" element={<ContactUs />}></Route>
          </Route>
          <Route path="/solo-landing" element={<SoloLanding />} />
          <Route path="/commander-landing" element={<CommanderLanding />} />
          <Route path="/getStartedFirst" element={<GetStartedFirstTime />} />

          {/* supplier routes starts */}
          <Route path="" element={<SupplierLayout />}>
            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/ConsultantList" element={<ConsultantList />} />
            <Route
              path="/SupplierTransfereeList"
              element={<SupplierTransfereeList />}
            />
            <Route
              path="/transfereeMore-details"
              element={<Transfereemoredetails />}
            />
            <Route path="/supplierSADetails" element={<MyProperty />} />
            <Route path="/ClientProfileList" element={<ClientProfileList />} />
            <Route path="/reports" element={<Reports />} />
            <Route
              path="/appointementreports"
              element={<AppointementReports />}
            />
            <Route path="/transfereereports" element={<TransfereeReports />} />
            <Route path="/billingreports" element={<BillingReports />} />
          </Route>
          {/*transferee routes */}
          <Route path="" element={<TransfereeLayout />}>
            <Route path="/dsLanding" element={<Dslanding />} />
            <Route path="/map-box-test" element={<BaseMap />} />
            <Route path="/dsHelp" element={<DSHelp />} />
            <Route path="/getStarted" element={<GetStarted />} />
            <Route path="/hire-an-expert" element={<HireanEexpert />} />
            {/* <Route path="/citylist" element={<Citylist />} /> */}
            <Route path="/citylist" element={<NewCityLanding />} />
            <Route path="/city-landing" element={<CityLanding />} />
            <Route path="/aiAssistant" element={<AIAssistant />} />
            {/* <Route path="/city-landing-new" element={<CityLanding />} /> */}
            <Route path="/myProperty" element={<MyProperties />} />
            <Route
              path="/property-details/"
              element={<PropertyListDetails />}
            />
            <Route path="/resources" element={<ResourceLanding />} />
            <Route path="/holiday-calendar" element={<HolidayCalendar />} />
            <Route
              path="/rentCalculator"
              element={<RentCalculatorPage />}
            ></Route>
            <Route path="/rental-faq" element={<RentalFAQ />}></Route>
            <Route path="/rentersresume" element={<RentersResume />} />
            <Route path="/petresume" element={<PetResume />} />
            <Route path="/Dei-data" element={<DieDetails />} />
            <Route path="/checklist" element={<CheckList />} />
            <Route path="/dsProfile" element={<DsProfile />} />
            <Route
              path="/my_property_details"
              element={<MyPropertyDetails />}
            />
            <Route path="/singleProfile" element={<DsSoloProfile />} />
            <Route path="/CompareMapList" element={<Maplist />} />
            {/* <Route path="/gdpr" element={<Gdpr />} /> */}
          </Route>
          {/* consultant routes */}
          <Route path="" element={<ConsultantLayout />}>
            <Route path="/SADetails" element={<MyProperty />} />
            <Route
              path="/ConsultantDashboard"
              element={<ConsultantDashboard />}
            />
            <Route
              path="/ConsultantUsageDashboard"
              element={<UsageDashboard />}
            />
            <Route path="/ConsultantSchedules" element={<Schedule />} />
            <Route
              path="/ConsultantTransfereeList"
              element={<TransfereeList />}
            />
            <Route path="/more-details" element={<MoreDetail />} />
            <Route path="/Properties" element={<Properties />} />
            <Route path="/consultantreports" element={<ConsultantReports />} />
            <Route
              path="/consultantappointementreports"
              element={<ConsultantAppointementReports />}
            />

            <Route
              path="/consultanttransfereereports"
              element={<ConsultantTransfereeReports />}
            />

            {/* <Route path="/Consultant" element={<Chat />} /> */}
            <Route path="/consultant" element={<Chatting />} />
            <Route path="/ConsultantProfile" element={<ConsultantProfile />} />
          </Route>

          <Route path="*" element={<NoPageFound />} />
        </Routes>
        </Suspense>
        </RouteErrorBoundary>
      </BrowserRouter>
    </LoadScript>
  );
};

export default AllRoutes;
